import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { filter, first, map } from 'rxjs/operators';

export const permissionsGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const requiredPermission = route.data?.['permission'];
  const requiredPermissionType = route.data?.['permissionType'];
  
  if (!requiredPermission) {
    return true;
  }

  return authService.permission$.pipe(
    filter(p => !!p && Object.keys(p).length > 0), // wait for permission to load
    first(),
    map(p => {
      const has = authService.hasPermission(requiredPermission, requiredPermissionType);

      if (has) {
        return true;
      }

      // Allowed candidate default routes (home, app, receipts, products)
      const defaultCandidates = ['home', 'receipts', 'app', 'products'];
      const urlSegments = state.url.split('/');
      const routeName = urlSegments[2] || '';

      for (const candidate of defaultCandidates) {
        if (candidate !== requiredPermission && authService.hasPermission(candidate, 'access')) {
          return router.createUrlTree(['/u', routeName, candidate]);
        }
      }

      return router.createUrlTree(['/auth/access']);
    })
  );
};
